import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { CmsContentService, UiTextDto } from './cms-content.service';

@Injectable({
  providedIn: 'root'
})
export class UitextService {

  private texts: Promise<{ [key: string]: UiTextDto }>;

  constructor(private cms: CmsContentService, @Inject(LOCALE_ID) private locale: string) {
    this.texts = firstValueFrom(
      this.cms.getAll(this.locale, 'ResultText').pipe(
        map(items => {
          const dict: { [key: string]: UiTextDto } = {};
          for (const item of items) {
            dict[item.key] = item;
          }
          return dict;
        })
      )
    );
  }

  async getHeader(category: string, subcategory: string): Promise<string> {
    let key = `si_pts_result_${category}_${subcategory}`;
    return await this.get(key, 'heading');
  }

  async getPopover(category: string, subcategory: string): Promise<string> {
    let key = `si_pts_result_${category}_${subcategory}`;
    return await this.get(key, 'text');
  }

  async getResult(category: string, subcategory: string, level: number): Promise<string> {
    let textlevel = level;
    if (level == 0)
      textlevel = 1;

    let key = `si_pts_result_${category}_${subcategory}_${textlevel}`;
    return await this.get(key, 'text');
  }

  async getTotalResultHeader(risk: number): Promise<string> {
    let key = `si_pts_result_total_${risk}`;
    return await this.get(key, 'heading');
  }

  async getTotalResultText(risk: number): Promise<string> {
    let key = `si_pts_result_total_${risk}`;
    return await this.get(key, 'text');
  }

  private async get(key: string, field: 'heading' | 'text'): Promise<string> {
    const texts = await this.texts;
    const item = texts[key];

    if (!item) {
      this.cms.reportMissing(key, this.locale);
      return key.replace("si_pts_result_", "");
    }

    const value = field === 'heading' ? item.heading : item.text;
    return value?.length ? value : key.replace("si_pts_result_", "");
  }
}
